import { createSlice } from '@reduxjs/toolkit';

const sectionSlice = createSlice({
  name: 'sections',
  initialState: {
    sections: [], // Initialize as an empty array
    status: 'idle',
    error: null,
  },
  reducers: {
    updateSections: (state, action) => {
      state.sections = action.payload;
      state.status = 'succeeded';
    },
    // Add other reducers as needed
  },
});

export const { updateSections } = sectionSlice.actions;

export const selectSections = (state) => state.sections.sections;

export default sectionSlice.reducer;
